<template>
  <ResultCard
    :image-url="targetNumUri"
    :num-uri-string="numUriString"
    :result="result"
    @click.native.prevent="onClick"
  >
    <template v-slot:header>{{ result.description }}</template>
    <template v-slot:description>{{ result["@L"] }}</template>
  </ResultCard>
</template>

<script>
import { resolvePath, parseNumUri, UrlPath } from "num-client";

import ResultCard from "@/views/Home/Card/Result";

import eventHub from "@/eventHub";

import router from "@/router";

import { formatNumUriString } from "@/utils/utils";

export default {
  name: "LinkCard",
  props: {
    numUriString: String,
    result: Object,
  },
  components: {
    ResultCard,
  },
  computed: {
    targetNumUri() {
      const link = this.result?.["@L"];
      if (!link) return;
      let result;

      if (this.isFullQuery(link)) {
        result = link;
      } else {
        let numUri = parseNumUri(this.numUriString);
        const newPath = resolvePath(numUri.path.s, link);
        numUri = numUri.withPath(new UrlPath(newPath));
        result = numUri.toString();
      }

      return result;
    },
  },
  methods: {
    isFullQuery(url) {
      return url.startsWith("num://");
    },
    onClick() {
      const parsedNumUri = formatNumUriString(this.targetNumUri);
      router.push({ query: { s: parsedNumUri } });
      // wait until NumResults component is mounted (which mounts after
      // parsing the query string in Home) and `force-search` event is ready
      // before emitting
      this.$nextTick(() => eventHub.$emit("force-search", parsedNumUri));
    },
  },
};
</script>
